import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import * as d3 from 'd3';

import metricsTools from '../../utils/metricsTools';
import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';

const pushAccountData = (res, timeRangeElement) => {
    res[0].values.push(
        [
            timeRangeElement.timeRange,
            timeRangeElement.storageUtilized,
        ]
    );
};

const pushQuotaData = (res, timeRangeElement, quota) => {
    res[1].values.push(
        [
            timeRangeElement.timeRange,
            quota,
        ]
    );
};

const formatDataForChart = (data, quota) => {
    const res = [
        {
            key: 'Total Storage',
            values: [],
            area: true,
            color: '#23afa6',
        },
    ];

    if (quota) {
        res.push({
            key: 'Quota',
            values: [],
            area: false,
            line: true,
            color: '#32CD32',
        });
    }

    // Remove future metrics
    const now = new Date();
    const metrics = data.filter(metric => new Date(metric.timeRange) <= now);
    for (let i = 0; i < metrics.length; i += 1) {
        const timeRangeElement = metrics[i];
        pushAccountData(res, timeRangeElement);
        if (quota) {
            pushQuotaData(res, timeRangeElement, quota);
        }
    }
    return res;
};

const context = {
    formatXAxis: d => (d3.time.format('%m/%d %H:%M')(new Date(d))),
    formatYAxis: d => metricsTools.bytesToSize(d),
};


class AreaChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="areChart"
              type="lineChart"
              datum={formatDataForChart(this.props.data, this.props.quota)}
              context={context}
              xAxis={{
                  tickFormat: {
                      name: 'formatXAxis',
                      type: 'function',
                  },
              }}
              yAxis={{
                  tickFormat: {
                      name: 'formatYAxis',
                      type: 'function',
                  },
              }}
              margin={{ right: 80, left: 40 }}
              useInteractiveGuideline={true}
              rightAlignYAxis={true}
              clipEdge={true}
              showControls={true}
              x={ d => {
                  const date = new Date(d[0]);
                  return date.getTime();
              }}
              y={ d => (d[1])}
              forceY={[0]}
              height={this.props.height || 400}
            />
          </div>
        );
    }
}

AreaChartComponent.propTypes = {
    data: PropTypes.array.isRequired,
    height: PropTypes.number,
    quota: PropTypes.number,
};

export default AreaChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/StorageAreaChartComponent.js
 **/